/**
 * 运营中心翻译 - 中文
 */
export const opsCenterZh = {
  title: '运营中心',
  subtitle: '面向 IT 与内部运营的统一治理工作台',

  m365Dormant: {
    title: 'M365 休眠账号',
    subtitle: '识别长时间未活动的 Microsoft 365 账号',

    statusBar: {
      lastSync: '上次同步',
      neverSynced: '尚未同步，请点击右侧按钮触发',
      success: '成功',
      running: '同步中...',
      failed: '失败',
      timeout: '同步超时',
      totalUsers: '共 {count} 人',
      changedUsers: '本次变化 {count} 人',
      syncButton: '立即同步',
      syncRunningSeconds: '已运行 {seconds} 秒',
      partialBanner:
        '正在同步新数据，已运行 {seconds} 秒。当前展示截至上次同步（{snapshotAt}）的数据。',
      failedBanner: '本次同步失败：{errorCode}。当前展示上次成功同步（{snapshotAt}）的数据。',
    },

    filters: {
      inactiveDaysLabel: '休眠天数 ≥',
      accountAgeMinLabel: '创建天数 ≥',
      keyword: '邮箱 / 显示名 / Mail',
      accountEnabled: '启用',
      accountEnabledAll: '全部',
      accountEnabledTrue: '启用',
      accountEnabledFalse: '禁用',
      hasLicense: 'License',
      hasLicenseAll: '全部',
      hasLicenseTrue: '有',
      hasLicenseFalse: '无',
      licenseType: 'License 类型',
      licenseTypeAll: '全部类型',
      exportCsv: '导出 CSV',
    },

    table: {
      column: {
        email: '邮箱 (UPN)',
        displayName: '显示名',
        department: '部门',
        accountEnabled: '启用',
        license: 'License',
        accountCreated: '创建时间',
        lastSignIn: '最后登录',
        lastAnyActivity: '最后活动',
        daysInactive: '休眠天数',
      },
      noActivity: '无记录',
      noActivityTooltip: '可能 license 不足或从未登录',
      noActivityNew: '新账号未登录',
      noActivityNewTooltip: '账号创建于 {daysAgo} 天前，尚未首次登录',
      noActivityOld: '从未登录',
      noActivityOldTooltip: '账号创建于 {daysAgo} 天前，从未登录过',
      noLicense: '无',
      licensesCountSuffix: '+{count}',
    },

    drawer: {
      tab: {
        overview: '概览',
        timeline: '活动时间线',
      },
      signInSection: '登录活动（接近实时，≤ 1 小时延迟）',
      serviceSection: '服务活动（Microsoft 离线统计，24-48 小时延迟）',
      licenseSection: 'License 列表',
      missingFromLatestTag: '上次同步未在 Graph 中见到，可能已禁用',
      accountCreatedAt: '账号创建时间',
      accountAgeDays: '已创建 {days} 天',
      timelineEmpty: '该用户暂无活动变更事件',
    },

    trend: {
      sectionTitle: '休眠趋势',
      thresholdLabel: '阈值',
      thresholdDays: '{n} 天',
      includeNeverSignedIn: '包含从未登录',
      empty: '尚无历史同步记录',
      approxTooltip: '近似值，按 30 天分桶聚合',
    },

    sync: {
      toast: {
        successTotal: '同步完成，共 {total} 人，休眠 {dormant} 人（按 {threshold} 天阈值）',
        failed: '同步失败：{errorCode} {errorMessage}',
      },
    },

    error: {
      AZURE_CREDENTIAL_MISSING:
        '请联系运维在 .env 中配置 AZURE_TENANT_ID / AZURE_CLIENT_ID / AZURE_CLIENT_SECRET',
      GRAPH_INSUFFICIENT_SCOPE:
        'Azure App Registration 缺少权限（AuditLog.Read.All 或 Reports.Read.All），请联系 IT 在 Azure Portal 补齐并 admin consent',
      REPORTS_OBFUSCATED:
        'M365 活动报告被脱敏。请在 M365 管理中心 → 设置 → 组织设置 → 报告 中关闭"在所有报告中显示去识别名称"',
      SYNC_IN_PROGRESS: '已有同步正在进行中',
      NO_SUCCESSFUL_SYNC: '尚未同步过 M365 数据，点击右上角"立即同步"开始',
      EXPORT_TOO_LARGE: '导出超过 50000 行上限，请缩小筛选条件',
      USER_NOT_FOUND: '用户不存在',
      LIST_LOAD_FAILED: '加载列表失败',
    },

    empty: {
      filtered: '当前条件下没有休眠账号',
      noBatch: '尚未同步过 M365 数据，点击右上角"立即同步"开始',
    },

    common: {
      retry: '重试',
      close: '关闭',
    },
  },
};
